import { ACTIONS } from '../../constants';

const initState = {
  active: false,
  lastLocation: '/',
  introPlayed: [],
};

const dataDetail = (state = initState, action) => {
  switch (action.type) {
    case ACTIONS.DETAIL_ACTIVE:
      return {
        ...state,
        active: action.isActive,
      };
    case ACTIONS.SAVE_LAST_LOCATION:
      return {
        ...state,
        lastLocation: action.lastLocation,
      };
    case ACTIONS.DETAIL_INTRO_PLAYED:
      return {
        ...state,
        introPlayed: [...state.introPlayed, action.category],
      };
    default:
      return state;
  }
};

export default dataDetail;



// WEBPACK FOOTER //
// ./src/redux/reducers/dataDetail.js